import './App.css';
import MainBlock from "./MainBlock/MainBlock";
import Footer from "./Footer/Footer";

function App() {
  return (
    <div style={{
        width: '100%',
        minHeight: '100vh',
        position: 'relative', // добавляем для контроля
        background: "url(/Background.png)",
        display: "flex",
        flexDirection: 'column',
        justifyContent: 'space-between',
    }}>
        {/*<img src="/Car.png" alt="car" style={{*/}
        {/*    margin: "0 100px",*/}
        {/*    position: 'absolute',*/}
        {/*    width: 'auto',*/}

        {/*}}/>*/}
        <div style={{
            display: 'flex',
            justifyContent: 'flex-start',
        }}>
            <MainBlock style={{
                maxWidth: "1500px",
                margin: 'auto',
            }}/>
        </div>
        <div>
            <Footer style={{
                maxWidth: "1500px",
                margin: 'auto',
                marginTop: '50px',
            }}/>
        </div>

    </div>
  );
}

export default App;
